<template>
  <v-popover
      placement="bottom-end"
      offset="10">
    <div class="text-icon w-6 h-6 cursor-pointer hover:text-icon-hover transition duration-200">
      <IconMoreSettings/>
    </div>
    <template #popover>
      <div class="text-md font-semibold text-left mb-2">{{ $t('currencyDisplayTitle') }}</div>
      <BaseRadioGroup :options="currencyDisplayOptions"
                      :value="currencyDisplay"
                      @change="$emit('change',{name:'currencyDisplay',val:$event})"/>
    </template>
  </v-popover>
</template>

<script>
import {mapGetters} from "vuex";
import transactionCurrencyDisplayProp from "@/mixins/transactionCurrencyDisplayProp";
import IconMoreSettings from "@/components/icons/IconMoreSettings";
import BaseRadioGroup from "@/components/UI/BaseRadioGroup";

export default {
  name: "TransactionsDisplaySettings",
  components: {BaseRadioGroup, IconMoreSettings},
  mixins: [transactionCurrencyDisplayProp],
  computed: {
    ...mapGetters('space', ['spaceInfo']),
    currencyDisplayOptions() {
      let symbol = this.spaceInfo.currency.symbol;
      return [
        {label: this.$t('displayTypeDefault'), value: 'default'},
        {label: this.$t('displayTypeSpaceBase', {symbol}), value: 'space_base'},
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        currencyDisplayTitle: 'Currency display',
        displayTypeDefault: 'In transaction account currency',
        displayTypeSpaceBase: 'In base currency ({symbol})',
      },
      ru: {
        currencyDisplayTitle: 'Вывод суммы',
        displayTypeDefault: 'В валюте счета операции',
        displayTypeSpaceBase: 'В базовой валюте ({symbol})',
      },
    }
  }
}
</script>